// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Bo8B","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3u37D"};